/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnumOption
 */
export interface EnumOption {
    /**
     * 枚举值（对应 separateStore）
     * @type {number}
     * @memberof EnumOption
     */
    value?: number;
    /**
     * 显示名称
     * @type {string}
     * @memberof EnumOption
     */
    label?: string;
}

/**
 * Check if a given object implements the EnumOption interface.
 */
export function instanceOfEnumOption(value: object): value is EnumOption {
    return true;
}

export function EnumOptionFromJSON(json: any): EnumOption {
    return EnumOptionFromJSONTyped(json, false);
}

export function EnumOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumOption {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function EnumOptionToJSON(json: any): EnumOption {
    return EnumOptionToJSONTyped(json, false);
}

export function EnumOptionToJSONTyped(value?: EnumOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'label': value['label'],
    };
}

